import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { NavLink } from 'ion-navchevron'
import logo from '../../static/general/glamour.svg'
import { Button } from 'semantic-ui-react'
import { MenuIco } from 'ion-icon'
import { DesktopTablet, Mobile } from 'ion-media'
import useHasMounted from '../useHasMounted'

const Header = (props) => {
  const hasMounted = useHasMounted()
  return (
    <header role='banner' className={props.useSmall ? 'reduced-header' : ''}>
      <a href='#main-content' className='show-on-focus' tabIndex='0'>
        Skip to content
      </a>
      <div className='wrapper'>
        <Mobile>
          <Button tabIndex='2' className='menu-btn' onClick={() => props.toggleMenu()}><MenuIco width='24' height='24' /></Button>
        </Mobile>
        <Link to='/' className='logo'>
          <img src={logo} alt='Glamour South Africa' />
        </Link>
      </div>
      {hasMounted &&
        <DesktopTablet>
          <div className='wrapper'>
            <nav>
              <ul>
                <li className='drop-dwn'>
                  <NavLink to='/fashion'>Fashion</NavLink>
                  <ul className='menu-articles'>
                    <li>
                      <Link to='/fashion/trends'>Trends</Link>
                    </li>
                    <li>
                      <Link to='/fashion/celebrity-style'>Celebrity Style</Link>
                    </li>
                    <li>
                      <Link to='/fashion/accessories'>Accessories</Link>
                    </li>
                    <li>
                      <Link to='/fashion/style-diary'>Style Diary</Link>
                    </li>
                  </ul>
                </li>
                <li className='drop-dwn'>
                  <NavLink to='/beauty'>Beauty</NavLink>
                  <ul className='menu-articles'>
                    <li>
                      <Link to='/beauty/hair'>Hair</Link>
                    </li>
                    <li>
                      <Link to='/beauty/trends'>Trends</Link>
                    </li>
                    <li>
                      <Link to='/beauty/makeup'>Makeup</Link>
                    </li>
                    <li>
                      <Link to='/beauty/skincare'>Skin Care</Link>
                    </li>
                    <li>
                      <Link to='/beauty/nails'>Nails</Link>
                    </li>
                    <li>
                      <Link to='/beauty/beauty-awards'>Beauty Awards</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <NavLink to='/celebrity-news'>Celebs</NavLink>
                </li>
                <li className='drop-dwn'>
                  <NavLink to='/lifestyle'>Lifestyle</NavLink>
                  <ul className='menu-articles'>
                    <li>
                      <Link to='/lifestyle/careers'>Careers</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/food-drink'>Food & Drink</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/travel'>Travel</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/weddings'>Weddings</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/man-candy'>Man Candy</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/glamour-guides'>Glam Guides</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/glam-book-club'>GLAM Book Club</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/women-in-charge'>Women in Charge</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/entertainment'>Entertainment</Link>
                    </li>
                    <li>
                      <Link to='/lifestyle/coastal-crush/'>Coastal Crush</Link>
                    </li>
                  </ul>
                </li>
                <li className='drop-dwn'>
                  <NavLink to='/wellness'>Wellness</NavLink>
                  <ul className='menu-articles'>
                    <li>
                      <Link to='/wellness/fitness-exercise'>Fitness &amp; Exercise</Link>
                    </li>
                    <li>
                      <Link to='/wellness/love-relationships'>Love &amp; Relationships</Link>
                    </li>
                    <li>
                      <Link to='/wellness/mindfulness'>Mindfulness</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <NavLink to='/events'>Events</NavLink>
                </li>
                <li>
                  <NavLink to='/win'>Win</NavLink>
                </li>
                <li className='drop-dwn'>
                  <NavLink to='/more'>More</NavLink>
                  <ul className='menu-articles'>
                    <li>
                      <Link to='/more/gift-guide'>Gift Guide</Link>
                    </li>
                    <li>
                      <Link to='/more/glam-x-skip'>GLAM x SKIP</Link>
                    </li>
                    <li>
                      <Link to='/more/glam-x-ciao-malfy'>GLAM x Ciao Malfy</Link>
                    </li>
                    <li>
                      <Link to='/more/glam-x-mac'>GLAM x MAC</Link>
                    </li>
                    <li>
                      <Link to='/more/glam-x-levi'>Curvy HQ</Link>
                    </li>
                    {/* <li>
                      <Link to='/more/sparkle-on-with-bernini'>Sparkle on with Bernini</Link>
                    </li> */}
                    {/* <li>
                      <Link to='/more/glam-x-ariel'>GLAM x Ariel</Link>
                    </li> */}
                    {/* <li>
                      <Link to='/more/glam-x-bulgari'>GLAM x Bulgari</Link>
                    </li> */}
                    <li>
                      <Link to='/more/glams-most-glam'>GLAM's Most GLAM</Link>
                    </li>
                    {/* <li>
                      <Link to='/more/style-your-smile'>#StyleYourSmile</Link>
                    </li> */}
                    <li>
                      <Link to='/more/women-of-the-year'>Women of the Year</Link>
                    </li>
                    <li>
                      <Link to='/more/betway-summer-cup'>Betway Summer Cup</Link>
                    </li>
                    {/* <li>
                      <Link to='/more/how-do-i-look-sa'>How Do I Look? SA</Link>
                    </li> */}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </DesktopTablet>}
    </header>
  )
}

export default connect((state) => ({ articles: state.articles }))(Header)
